import { Block, Flex, IconButton } from '@aloft/toolkit-sui';

import { shouldShowHeaderNavigationForV2 } from '../../layout/shouldShowHeaderNavigationForV2.tsx';
import { useModuleContext } from '../../modules/shared/moduleContext/useModuleContext.ts';
import { borderColor, borderSideStyle, borderWidth } from '../../styles/border.ts';
import { DEFAULT_SIDEBAR_WIDTH } from '../../styles/sidebar.ts';
import { HeaderNav } from './HeaderNav/HeaderNav.tsx';
import { LogoHomeLink } from './LogoHomeLink.tsx';

export const MainHeaderOrderNavigation = ({
  isCollapsed,
  onCollapseToggle,
}: {
  isCollapsed: boolean;
  onCollapseToggle?: () => void;
}) => {
  const {
    navigation: { useParams },
  } = useModuleContext();

  const { orderId } = useParams();

  const shouldShowHeaderNavigation =
    !!orderId && shouldShowHeaderNavigationForV2(window.location.pathname);

  return (
    <Flex
      alignItems="center"
      justifyContent="space-between"
      width={
        !isCollapsed && onCollapseToggle && !shouldShowHeaderNavigation
          ? DEFAULT_SIDEBAR_WIDTH
          : undefined
      }
      gap={2}
      height={shouldShowHeaderNavigation ? undefined : '58px'}
      paddingLeft={2}
      {...(!isCollapsed &&
        onCollapseToggle &&
        !shouldShowHeaderNavigation && {
          borderRightWidth: borderWidth,
          borderRightColor: borderColor,
          borderRightStyle: borderSideStyle,
          backgroundColor: 'surface1',
        })}
    >
      {!shouldShowHeaderNavigation && <LogoHomeLink />}
      {onCollapseToggle && !shouldShowHeaderNavigation && (
        <Block>
          <IconButton
            ariaLabel="collapse-toggle"
            icon={isCollapsed ? 'side-nav-expand-2' : 'side-nav-collapse-2'}
            onClick={onCollapseToggle}
            variant="tertiary"
            size="md"
            __dangerDoNotUseSx={{ svg: { height: '22px', width: '22px' } }}
          />
        </Block>
      )}
      {shouldShowHeaderNavigation && <HeaderNav />}
    </Flex>
  );
};
